import React, { useState, useEffect } from "react";
import axios from "axios";
import "../registr/Register.css";
import { Typography } from '@mui/material';
import { useAuth } from '../auth/Auth';

const Register = () => {
  const [values, setValues] = useState({
    username: "",
    email: "",
    password: ""
  });
  const { user } = useAuth()

  const [emailAlreadyExists, setEmailAlreadyExists] = useState(false); 
  const [usernameAlreadyExists, setUsernameAlreadyExists] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    const userId = user?.user_id;
    const userRule = user?.role;
    if (userId && userRule !== 1) {
      window.location.href = "/";
    }
  }, [user]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (values.password !== values.confirmPassword) {
      setPasswordMatch(false);
    } else {
      axios
        .post("https://hub2.daolog.net/signup", values)
        .then((res) => {
          console.log("Registered Successfully!!");
          window.location.href = "/Login";
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 400) {
            if (err.response.data.message === "Username already exists") {
              setUsernameAlreadyExists(true);
            } else if (err.response.data.message === "Email already exists") {
              setEmailAlreadyExists(true);
            }
          }
        });
    }
  };

  return (
    <div style={{
      marginTop: "120px",
    }}>
      <Typography variant="h5" >Створити акаунт клієнту</Typography>
   
      <div className="br-m" style={{
        marginTop: "10px",
      }}>
        <div className="container-about">
          <form onSubmit={handleSubmit}>
            <label style={{
              display: "flex",
              flexDirection: "column",
              width: "380px",
              marginLeft: "auto",
              marginTop: "10px",
              marginRight: "auto",
              alignItems: "center",
            }}>
              Username:
              <input
                className="input-stl"
                style={{
                  marginTop: "10px", backgroundColor: "rgb(213, 220, 255)"
                }}
                placeholder="Username"
                type="text"
                name="username"
                onChange={handleChange}
              />
              {usernameAlreadyExists && (
                <div style={{
                  color: "red",
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "auto",
                  marginTop: "10px",
                  marginRight: "auto",
                  alignItems: "center",
                }}>
                  Username already exists!
                </div>
              )}
            </label>

            <br />
            <label style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "auto",
              marginRight: "auto",
              alignItems: "center",
            }}>
              Email:
              <input
                className="input-stl"
                style={{
                  marginTop: "10px", backgroundColor: "rgb(213, 220, 255)"
                }}
                placeholder="Email"
                type="email"
                name="email"
                onChange={handleChange}
              />
              {emailAlreadyExists && (
                <div style={{
                  color: "red",
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "auto",
                  marginTop: "10px",
                  marginRight: "auto",
                  alignItems: "center",
                }}>Email already exists!</div>
              )}
            </label>
            <br />
      
            <label style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "auto",
              marginRight: "auto",
              alignItems: "center",
            }}>
              Password:
              <input
                className="input-stl"
                style={{
                  marginTop: "10px", backgroundColor: "rgb(213, 220, 255)"
                }}
                placeholder="Password"
                type="password"
                name="password"
                onChange={handleChange}
              />
            </label>
            <br />
            <label style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "auto",
              marginRight: "auto",
              alignItems: "center",
            }}>
              Confirm Password:
              <input
                className="input-stl"
                style={{
                  marginTop: "10px", backgroundColor: "rgb(213, 220, 255)"
                }}
                placeholder="Confirm Password"
                type="password"
                name="confirmPassword"
                onChange={handleChange}
              />
            </label>
            {!passwordMatch && (
              <div style={{
                color: "red",
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginTop: "10px",
                marginRight: "auto",
                alignItems: "center",
              }}>
                Passwords do not match!
              </div>
            )}
            <br />
            <button
            className="download-button"
              type="submit"
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginRight: "auto",
                alignItems: "center",
                minWidth: "50px",
                maxWidth: "200px",
                width: "100%",
                marginBottom: "15px",
              }}
            >
              Створити нового користувача
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;